import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ISmartSendContext } from '../context/SmartSendContextModels';
import GenerateOptions from './SmartSendBulkActionOptions';
import { ApplierOption } from './ApplierOption';
import { GetSelectedItems } from './GetSelectedItems';

export function GetSelectionBasedOnAction(
  filterKey: string,
  state: ISmartSendContext,
  action: ApplierOption,
  smartSendItemsCache: SmartSendItemApiModel[]
): SmartSendItemApiModel[] {
  return GetSelectedItems(filterKey, state, smartSendItemsCache).filter((i) =>
    GenerateOptions(i, i.State.validation).includes(action)
  );
}
